import { TabsMenu as TabsMenuUI } from "artisn-ui-react";
import { useRouter } from "next/router";
import React from "react";

import Styles from "./LoyaltyTabsMenuItem.styles";
import { LoyaltyTabsMenuItemProps as Props } from "./LoyaltyTabsMenuItem.types";
import useI18n from "hooks/useI18n";

import StarSVG from "../../../../../public/assets/images/TabsMenu/star.svg";

const { Item } = TabsMenuUI;

const LoyaltyTabsMenuItem: React.FC<Props> = props => {
  const { className, hideTitle, active } = props;
  const { push } = useRouter();
  const t = useI18n();

  const onClickHandler = async () => {
    await push("/loyalty");
  };

  return (
    <Styles className={`LoyaltyTabsMenuItem ${className}`} active={active}>
      <Item
        icon={StarSVG}
        title={hideTitle ? undefined : t.navigation.loyalty}
        onClick={onClickHandler}
      />
    </Styles>
  );
};

LoyaltyTabsMenuItem.defaultProps = {
  className: ""
};

export default LoyaltyTabsMenuItem;
